export const FETCH_STANDALONE_MODE_REQUEST = 'FETCH_STANDALONE_MODE_REQUEST';
export const FETCH_STANDALONE_MODE_SUCCESS = 'FETCH_STANDALONE_MODE_SUCCESS';
export const FETCH_STANDALONE_MODE_FAILURE = 'FETCH_STANDALONE_MODE_FAILURE';

export const UPDATE_STANDALONE_MODE_REQUEST = 'UPDATE_STANDALONE_MODE_REQUEST';
export const UPDATE_STANDALONE_MODE_SUCCESS = 'UPDATE_STANDALONE_MODE_SUCCESS';
export const UPDATE_STANDALONE_MODE_FAILURE = 'UPDATE_STANDALONE_MODE_FAILURE';
